import { FaRegSave, FaShare } from "react-icons/fa";
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ModalWrapper } from "./styled"
import { tourActions } from 'redux/slice/tourSlice'
import NotFoundImage from 'assets/images/no-image-found.png'
import ShowToast from "utils/ShowToast";
import { tourSelector } from 'redux/selector'
import Input from "components/Input/index.js";
import Label from "components/Label/index.js";
import ButtonIcon from "components/ButtonIcon/index.js";
import { getAll } from 'services/infoAddressServices'
import ErrorMessage from "components/ErrorMessage"
import { tourError } from "errors/tourError"

const Modal = ({ selectedId, showModal, hidden, tourTypeData, method, querySearch, currentPage, sort, setCurrentPage, tourType }) => {
    const dispatch = useDispatch()
    const imageRef = useRef()
    const tourState = useSelector(tourSelector)

    const [editorState, setEditorState] = useState(EditorState.createWithContent(
        ContentState.createFromBlockArray(
            convertFromHTML('<p></p>')
        )
    ));
    let title = ''
    if (method === 'add') {
        title = 'Thêm tour'
    }
    if (method === 'show') {
        title = 'Chi tiết tour'
    }
    if (method === 'update') {
        title = 'Cập nhật tour'
    }
    if (method === 'remove') {
        title = 'Xóa tour'
    }
    const formData = useFormik({
        initialValues: {
            tour_id: "",
            name: "",
            tour_type_id: tourTypeData[0]?.id,
            thumbnail: "",
            price: 0,
            discount: 0,
            min_person: 1,
            max_person: 2,
            province: "1",
            district: "1",
            wards: "1",
            specific_address: "",
            content: "",
            created_at: "",
            status: 0,

        },
        validationSchema: Yup.object({
            name: Yup.string().trim().required(tourError.requiredName),
            thumbnail: Yup.string().trim().required(tourError.requiredThumbnail),
            specific_address: Yup.string().trim().required(tourError.requiredSpecificAddress),
            max_person: Yup.number().test(
                "region_valid",
                tourError.personValid,
                function (value) {
                    const { min_person } = this.parent;
                    return validatePerSon(min_person, value);
                }
            ),
        }),
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (values, { setFieldError }) => {
            if (method === 'add') {
                const convert = draftToHtml(convertToRaw(editorState.getCurrentContent()))
                values.content = convert
                delete values['tour_id']
                delete values['created_at']
                dispatch(tourActions.addTour({ data: values, setFieldError, ShowToast, querySearch, sort, currentPage, tourType, hidden, handleSetDefaultForm }))
            }
            if (method === 'update') {
                const convert = draftToHtml(convertToRaw(editorState.getCurrentContent()))
                values.content = convert
                delete values['tour_id']
                delete values['created_at']
                dispatch(tourActions.updateTour({ data: values, id: selectedId, setFieldError, ShowToast, querySearch, sort, currentPage, tourType, hidden, handleSetDefaultForm }))
            }
            if (method === 'remove') {
                dispatch(tourActions.removeTour({ id: selectedId, ShowToast, querySearch, sort, currentPage, setCurrentPage, tourType }))
                handleSetDefaultForm()
                hidden()
            }
        }
    })

    function validatePerSon(min, max) {
        if (max <= min) {
            return false
        }
        return true
    }


    useEffect(() => {
        if (tourTypeData.length > 0) {
            formData.setFieldValue("tour_type_id", tourTypeData[0].id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tourTypeData])

    function handleSetDefaultForm() {
        setEditorState(EditorState.createWithContent(
            ContentState.createFromBlockArray(
                convertFromHTML('<p></p>')
            )
        ))
        formData.setValues({
            tour_id: "",
            name: "",
            tour_type_id: tourTypeData[0]?.id,
            thumbnail: "",
            price: 0,
            discount: 0,
            min_person: 1,
            max_person: 2,
            province: "1",
            district: "1",
            wards: "1",
            specific_address: "",
            content: "",
            created_at: "",
            status: 0,

        })

        formData.setTouched({}, false);
        formData.setErrors({})
    }


    const handleCloseModal = () => {
        handleSetDefaultForm()
        hidden()
    }


    const handleErrorImage = () => {
        imageRef.current.src = NotFoundImage
    }

    //load address
    const [province, setProvince] = useState([])
    const [dataDistrict, setDataDistrict] = useState([])
    const [dataWards, setDataWards] = useState([])
    useEffect(() => {
        const loadAddress = async () => {
            const result = await getAll()
            setProvince(result)
            // eslint-disable-next-line array-callback-return
            result.map(item => {
                if (item.code === 1) {
                    setDataDistrict((item.districts));
                    // eslint-disable-next-line array-callback-return
                    item.districts.map(item => {
                        if (item.code === 1) {
                            setDataWards(item.wards);
                        }
                    })
                }
            })
        }
        loadAddress()

    }, [])


    const handleChangeProvince = (e) => {
        let newDistrict = []
        province?.forEach(item => {
            if (item.code == e.target.value) {
                newDistrict = [...item.districts]
            }
        })
        formData.setFieldValue("province", e.target.value)
        setDataDistrict(newDistrict)

        setDataWards(newDistrict[0].wards)
    }
    const handleChangeDistricts = (e) => {
        let newWard = []
        dataDistrict.forEach(item => {
            if (item.code == e.target.value) {
                newWard = [...item.wards]
            }
        })
        formData.setFieldValue("district", e.target.value)
        setDataWards(newWard)

        formData.setFieldValue("wards", (newWard[0].code))

    }
    const handleChangeWard = (e) => {
        formData.setFieldValue("wards", e.target.value)

    }

    useEffect(() => {
        if (selectedId !== null) {
            const data = tourState.tourList.filter(item => item.tour_id === selectedId)
            formData.setValues({
                tour_id: data[0].tour_id,
                name: data[0].tour_name,
                tour_type_id: data[0].tour_type_id,
                thumbnail: data[0].thumbnail ?? "",
                price: data[0].price,
                discount: data[0].discount,
                min_person: data[0].min_person,
                max_person: data[0].max_person,
                province: data[0].province ?? "",
                district: data[0].district ?? "",
                wards: data[0].wards ?? "",
                specific_address: data[0].specific_address ?? "",
                content: data[0].content ?? "",
                created_at: data[0].created_at,
                status: data[0].status,
            });

            setEditorState(data[0].content !== null
                ? EditorState.createWithContent(
                    ContentState.createFromBlockArray(
                        convertFromHTML(data[0].content)
                    )
                )
                : EditorState.createWithContent(
                    ContentState.createFromBlockArray(
                        convertFromHTML('<p></p>')
                    )
                )
            )

            province?.forEach(item => {
                if (item.code == data[0].province) {
                    setDataDistrict(item.districts)
                    item.districts.forEach(district => {
                        if (district.code == data[0].district) {
                            setDataWards(district.wards)
                        }
                    })
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedId, showModal, tourState.productList])

    return (
        <ModalWrapper>
            <div className="amep">
                <div className='amep_overlay'
                    onClick={handleCloseModal}
                    style={
                        showModal ? {
                            transform: 'translateY(0%)',
                            opacity: 1
                        } : {
                            transform: 'translateY(-120%)',
                            opacity: 0
                        }
                    }
                ></div>
                <form onSubmit={formData.handleSubmit}>
                    <div className='amep_container'
                        style={
                            showModal ? {
                                transform: 'translateY(0%)',
                                opacity: 1
                            } : {
                                transform: 'translateY(-120%)',
                                opacity: 0
                            }
                        }
                    >
                        <h1 className='amep_header'>{title}</h1>
                        <ul className='amep_body'>
                            <li className='amep_item'>
                                <div className='amep_item_image mb-20'>
                                    <div className="image_box">
                                        <img
                                            onError={handleErrorImage}
                                            ref={imageRef}
                                            src={formData.values.thumbnail || NotFoundImage}
                                            alt='photos' />
                                    </div>

                                </div>
                                <Input
                                    placeholder='Đường dẫn ảnh...'
                                    name="thumbnail"
                                    className="mt-5"
                                    value={formData.values.thumbnail}
                                    onChange={formData.handleChange}
                                    onBlur={formData.handleBlur}
                                    readOnly={(method === 'show' || method === 'remove') ? true : false}
                                    isError={!!formData.errors.thumbnail}
                                    message={formData.errors.thumbnail}
                                />
                            </li>
                            {
                                method !== 'add' &&
                                <li className='amep_item'>
                                    <div className='amep_item_input'>
                                        <Label htmlFor='amep_item_input_id' className="mt-5">Mã tour:</Label>
                                        <Input
                                            id="amep_item_input_id"
                                            name="tour_id"
                                            value={formData.values.tour_id}
                                            onChange={formData.handleChange}
                                            onBlur={formData.handleBlur}
                                            readOnly={true}
                                        />
                                    </div>
                                </li>
                            }
                            <li className='amep_item'>
                                <div className='amep_item_input'>
                                    <Label htmlFor='amep_item_input_name' className="mt-15 mb-5">Tên tour:</Label>
                                    <Input
                                        id="amep_item_input_name"
                                        placeholder="Nhập tên tour..."
                                        name="name"
                                        value={formData.values.name}
                                        onChange={formData.handleChange}
                                        onBlur={formData.handleBlur}
                                        readOnly={(method === 'show' || method === 'remove') ? true : false}
                                        isError={!!formData.errors.name}
                                        message={formData.errors.name}
                                    />
                                </div>

                            </li>
                            <li className='amep_item'>
                                <div className='amep_item_input'>
                                    <Label className="mt-15 mb-5">Loại tour:</Label>
                                    <select
                                        name="tour_type_id"
                                        value={formData.values.tour_type_id}
                                        className="b-grey-1"
                                        onChange={formData.handleChange}
                                        onBlur={formData.handleBlur}
                                        disabled={(method === 'show' || method === 'remove') ? true : false}
                                    >
                                        {
                                            tourTypeData.map((item, index) => (
                                                <option key={index} value={item.id}>{item.name}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </li>
                            <li className='amep_item'>
                                <div className='amep_item_input'>
                                    <Label htmlFor='amep_item_input_price' className="mt-15 mb-5">Giá tour:</Label>
                                    <Input
                                        type='number'
                                        min={0}
                                        id="amep_item_input_price"
                                        placeholder="Nhập giá..."
                                        name="price"
                                        value={formData.values.price}
                                        isError={!!formData.errors.price}
                                        message={formData.errors.price}
                                        onChange={formData.handleChange}
                                        onBlur={formData.handleBlur}
                                        readOnly={(method === 'show' || method === 'remove') ? true : false}
                                    />
                                </div>
                            </li>
                            <li className='amep_item'>
                                <div className='amep_item_input'>
                                    <Label htmlFor='amep_item_input_discount' className="mt-15 mb-5">Giảm giá:</Label>
                                    <Input
                                        type="number"
                                        min={0}
                                        id="amep_item_input_discount"
                                        placeholder="Nhập giảm giá..."
                                        name="discount"
                                        value={formData.values.discount}
                                        isError={formData.errors.discount}
                                        message={formData.errors.discount}
                                        onChange={formData.handleChange}
                                        onBlur={formData.handleBlur}
                                        readOnly={(method === 'show' || method === 'remove') ? true : false}
                                    />
                                </div>
                            </li>
                            <li className='amep_item'>
                                <div className='amep_item_input'>
                                    <Label htmlFor='amep_item_input_discount' className="mt-15 mb-5">Số người tối thiểu:</Label>
                                    <Input
                                        type="number"
                                        min={0}
                                        id="amep_item_input_discount"
                                        placeholder="Nhập số người tối thiểu..."
                                        name="min_person"
                                        value={formData.values.min_person}
                                        isError={formData.errors.min_person}
                                        message={formData.errors.min_person}
                                        onChange={formData.handleChange}
                                        onBlur={formData.handleBlur}
                                        readOnly={(method === 'show' || method === 'remove') ? true : false}
                                    />
                                </div>
                            </li>
                            <li className='amep_item'>
                                <div className='amep_item_input'>
                                    <Label htmlFor='amep_item_input_discount' className="mt-15 mb-5">Số người tối đa:</Label>
                                    <Input
                                        type="number"
                                        min={0}
                                        id="amep_item_input_discount"
                                        placeholder="Nhập số người tối thiểu..."
                                        name="max_person"
                                        value={formData.values.max_person}
                                        isError={formData.errors.max_person}
                                        message={formData.errors.max_person}
                                        onChange={formData.handleChange}
                                        onBlur={formData.handleBlur}
                                        readOnly={(method === 'show' || method === 'remove') ? true : false}
                                    />
                                </div>
                            </li>
                            {
                                method !== "add" &&
                                <li className='amep_item'>
                                    <div className='amep_item_input'>
                                        <Label className="mt-15 mb-5">Trạng thái:</Label>
                                        <select
                                            name="tour_type_id"
                                            className="b-grey-1"
                                            value={formData.values.status}
                                            onChange={(e) => formData.setFieldValue("status", e.target.value)}
                                            onBlur={formData.handleBlur}
                                            disabled={(method === 'show' || method === 'remove') ? true : false}
                                        >
                                            <option value={0}>Hoạt động</option>
                                            <option value={1}>Tạm dừng</option>

                                        </select>
                                    </div>
                                </li>
                            }
                            <li className='amep_item'>
                                <div className='amep_item_input'>
                                    <Label className="mt-15 mb-5">Tỉnh/Thành phố:</Label>
                                    <select
                                        name="tour_type_id"
                                        className="b-grey-1"
                                        onChange={handleChangeProvince}
                                        value={formData.values.province}
                                        onBlur={formData.handleBlur}
                                        disabled={(method === 'show' || method === 'remove') ? true : false}
                                    >
                                        {
                                            province?.map((item, index) => (
                                                <option value={item.code} key={index}>{item.name}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </li>
                            <li className='amep_item'>
                                <div className='amep_item_input'>
                                    <Label className="mt-15 mb-5">Quận/Huyện:</Label>
                                    <select
                                        name="tour_type_id"
                                        className="b-grey-1"
                                        onChange={handleChangeDistricts}
                                        value={formData.values.district}
                                        onBlur={formData.handleBlur}
                                        disabled={(method === 'show' || method === 'remove') ? true : false}
                                    >

                                        {
                                            dataDistrict?.map((item, index) => (
                                                <option value={item.code} key={index}>{item.name}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </li>
                            <li className='amep_item'>
                                <div className='amep_item_input'>
                                    <Label className="mt-15 mb-5">Xã/Phường:</Label>
                                    <select
                                        name="tour_type_id"
                                        className="b-grey-1"
                                        onChange={handleChangeWard}
                                        value={formData.values.wards}
                                        onBlur={formData.handleBlur}
                                        disabled={(method === 'show' || method === 'remove') ? true : false}
                                    >

                                        {
                                            dataWards?.map((item, index) => (
                                                <option value={item.code} key={index}>{item.name}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </li>
                            <li className='amep_item_input'>
                                <div className='amep_item_input'>
                                    <Label className="mt-15 mb-5">Địa chỉ cụ thể:</Label>
                                    {
                                        formData.errors.specific_address &&
                                        <ErrorMessage>{formData.errors.specific_address}</ErrorMessage>
                                    }
                                    <textarea
                                        id="amep_item_input_specific_address"
                                        name="specific_address"
                                        value={formData.values.specific_address}
                                        onChange={formData.handleChange}
                                        onBlur={formData.handleBlur}
                                        className={` ${formData.errors.specific_address ? "bg-grey2 b-red-1" : "bg-white"}`}
                                        readOnly={(method === 'show' || method === 'remove') ? true : false}
                                    ></textarea>
                                </div>
                            </li>
                            {
                                method !== 'add' &&
                                <li className='amep_item'>
                                    <div className='amep_item_input'>
                                        <Label htmlFor='amep_item_input_other_createAt' className="mt-15 mb-5">Ngày thêm:</Label>
                                        <Input
                                            id="amep_item_input_other_createAt"
                                            name="created_at"
                                            type='date'
                                            value={formData.values.created_at}
                                            onChange={formData.handleChange}
                                            readOnly={(method === 'show' || method === 'remove') ? true : false}
                                        />
                                    </div>
                                </li>
                            }
                            <li className='amep_item'>
                                <div className='amep_item_input'>
                                    <Label htmlFor='amep_item_input_other_content' className="mt-15 mb-5">Mô tả tour:</Label>
                                    <div style={{ border: "1px solid #999", borderRadius: '4px', padding: '2px', minHeight: '450px', maxHeight: '450px' }}>
                                        <Editor
                                            editorState={editorState}
                                            onEditorStateChange={setEditorState}
                                            readOnly={(method === 'show' || method === 'remove') ? true : false}
                                        />
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className='amep_footer'>
                            <ButtonIcon
                                type='submit'
                                icon={<FaRegSave />}
                                classButton="action-danger-1"
                                isNa={tourState.isFetching}
                            >

                                Lưu
                            </ButtonIcon>
                            <ButtonIcon type='button'
                                onClick={handleCloseModal}
                                icon={<FaShare />}
                                classButton="action-primary"
                            >

                                Thoát
                            </ButtonIcon>
                        </div>
                    </div>
                </form>
            </div>
        </ModalWrapper>
    );
}

export default Modal;